import SecondaryCtas from './SecondaryCtas'

export default SecondaryCtas
